import React from 'react';

export default function IconBoxStyle11({ title, subTitle, iconSrc, subTitle2, show=false }) {
  return (
    <div className="cs_iconbox cs_style_11 cs_radius_25 text-wrap">
     {!show && <div className="cs_iconbox_icon lg:hidden">
        <img src={iconSrc} alt="Icon" />
      </div>}
     <div className="cs_iconbox_icon hidden lg:flex">
        <img src={iconSrc} alt="Icon" />
      </div>
      <div className="cs_iconbox_right">
        <h3 className="cs_iconbox_title cs_fs_24 mb-0">{title}</h3>
        <p className="cs_iconbox_subtitle mb-0 cs_heading_color text-wrap whitespace-normal">{subTitle}</p>
        <p className="cs_iconbox_subtitle mb-0 cs_heading_color pt-2">{subTitle2}</p>
      </div>
    </div>
  );
}
